import axios from "axios";

/*
In order to switch between development and production comment the baseURL and allow all origins on Flask backend
*/
const instance = axios.create({
    //baseURL: "http://127.0.0.1:5000/api",
    baseURL: "https://www.paraglidingrome.com/api",
    timeout: 1000 * 10,
});

export default instance;
